module.exports = __webpack_public_path__ + "c96656d9faaf4536178ed64617be6b91.svg";